import angular from 'angular';
import uiRouter from 'angular-ui-router';

import BillAtTableDetailsComponent from './billAtTable.component';

const billAtTableDetailsModule = angular.module('tinaba.components.services.billAtTable', [
  uiRouter
])
.config(($stateProvider) => {
  'ngInject';
  $stateProvider.state('services.billAtTable', {
    url: '/billAtTable',
    template: '<bill-at-table-details></bill-at-table-details>'
  });
})

.component('billAtTableDetails', BillAtTableDetailsComponent);

export default billAtTableDetailsModule;



/** WEBPACK FOOTER **
 ** ./client/app/components/services/billAtTable/billAtTable.js
 **/